import {Mutation, MutationTree} from 'vuex';
import StateType, {GlobalDataType} from '@/store/types/StateType';

import {merge} from 'lodash'

import IconCache from '@/mixins/IconCache';


const setGlobalState: Mutation<StateType> = (
	state,
	data: GlobalDataType
) => (state.global = {...state.global, ...data});

const updateLocale: Mutation<StateType> = (
	state,
	payload
) => (state.locale = payload);

const updateAnim: Mutation<StateType> = (
	state,
	payload
) => (state.animationComplete = payload);

const updateScrollToInfo: Mutation<StateType> = (
	state,
	payload
) => {
	state.scrollToInfo.scrollDir = payload.scrollDir;
	state.scrollToInfo.lastScrollTop = payload.lastScrollTop;
	return state;
};

const setFetchingData: Mutation<StateType> = (
	state,
	data: { key: string, state: boolean }
) => (state.fetching = merge(state.fetching, {[data.key]: data.state}));


const setMenu: Mutation<StateType> = (
	state,
	payload: {
		isOpen: boolean
	}
) => (state.menu.isOpen = payload.isOpen);

const updateLocation: Mutation<StateType> = (
	state,
	payload
) => (state.location = payload);

const setAnimationCardsName: Mutation<StateType> = (
	state,
	data: { key: string, state: string[] }
) => {
	if (state.animationCards && state.animationCards[data.key]) {
		state.animationCards[data.key] = data.state;
	}
	return state;
};

const setActiveModal: Mutation<StateType> = (
	state,
	payload: string | null
) => (state.activeModal = payload);

const setCardsIncluded: Mutation<StateType> = (
	state,
	payload: any
) => (state.cardsIncluded = payload);

const setHelpCategory: Mutation<StateType> = (
	state,
	payload
) => (state.help.activeCategory = payload);

const setHelpSection: Mutation<StateType> = (
	state,
	payload
) => (state.help.activeItem = payload);

const addIcon: Mutation<StateType> = async (
	state,
	payload: { name: string, value: string }
) => {
	await state.iconCache.set(payload.name, payload.value);
	state.iconCacheTracker++;

	IconCache.setStorageCache(state.iconCache);

	return state;
};

const removeIcon: Mutation<StateType> = async (
	state,
	payload: { name: string, value: string }
) => {
	await state.iconCache.delete(payload.name);
	state.iconCacheTracker--;

	IconCache.setStorageCache(state.iconCache);

	return state;
};

const updateHeaderInfo: Mutation<StateType> = (
	state,
	payload
) => (state.headerInfo = {...state.headerInfo, ...payload});


const setCookies: Mutation<StateType> = (
	state,
	cookies: boolean
) => (state.cookies = cookies);


const setCookiesHeight: Mutation<StateType> = (
	state,
	height: number
) => (state.cookiesHeight = height);

const setPreloaded: Mutation<StateType> = (
	state,
	preloaded: boolean
) => (state.global.preloaded = preloaded);

const setRecaptchaState: Mutation<StateType> = (
	state,
	payload
) => (state.recaptcha = payload);


const mutations: MutationTree<StateType> = {
	updateLocale,
	addIcon,
	removeIcon,
	setMenu,
	updateLocation,
	updateAnim,
	setCookies,
	updateHeaderInfo,
	setCookiesHeight,
	setFetchingData,
	setHelpCategory,
	setHelpSection,
	setCardsIncluded,
	setGlobalState,
	setActiveModal,
	setAnimationCardsName,
	setRecaptchaState,
	updateScrollToInfo,
	setPreloaded
};

export default mutations;
